import script from "./TrainDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrainDetails.vue?vue&type=script&setup=true&lang=ts"

import "./TrainDetails.vue?vue&type=style&index=0&id=59e4f228&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59e4f228"]])

export default __exports__